<template>
    <v-card :disabled="loading" :loading="loading" outlined>
        <v-card-title
            >รายการวันหยุดหวย{{ lottoName }} ประจำปี {{ year }}</v-card-title
        >
        <v-card-text>
            <span
                class="blue-grey--text"
                v-show="holidays.length == 0 && !loading"
                >ไม่พบข้อมูลรายการวันหยุด</span
            >
            <v-progress-circular
                color="primary"
                class="d-block mx-auto"
                v-if="loading"
                indeterminate
            ></v-progress-circular>
            <v-simple-table v-show="holidays.length > 0">
                <thead>
                    <tr>
                        <th>วันหยุด</th>
                        <th>จัดการ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="h in holidays" :key="h.id">
                        <td>{{ h.m_date.format("วัน ddd ที่ LL") }}</td>
                        <td>
                            <v-btn
                                color="error"
                                small
                                @click="selectIdForDelete(h.id)"
                                :disabled="on_delete"
                                ><v-icon>mdi-delete</v-icon> ลบวันหยุด</v-btn
                            >
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>

            <v-dialog v-model="showConfimDelete" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline"
                        >ยืนยันการลบข้อมูล?</v-card-title
                    >
                    <v-card-text
                        >กรุณาตรวจสอบวันที่ก่อนทำรายการทุกครั้ง</v-card-text
                    >
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="green darken-1"
                            text
                            @click="showConfimDelete = false"
                            >ยกเลิก</v-btn
                        >
                        <v-btn
                            color="green darken-1"
                            text
                            @click="deleteHoliday"
                            >ยืนยัน</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="on_delete"
                hide-overlay
                persistent
                disabled
                width="300"
            >
                <v-card color="primary" dark>
                    <v-card-text>
                        กำลังลบข้อมูลกรุณารอสักครู่
                        <v-progress-linear
                            indeterminate
                            color="white"
                            class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        loading: Boolean,
        lottoName: String,
        year: Number,
        holidays: Array,
    },

    data: () => {
        return {
            showConfimDelete: false,
            delete_id: null,
            on_delete: false,
        };
    },

    methods: {
        selectIdForDelete(id) {
            this.showConfimDelete = true;
            this.delete_id = id;
        },

        async deleteHoliday() {
            if (!this.delete_id) return;
            this.on_delete = true;
            this.showConfimDelete = false;
            try {
                const data = await this.$store.dispatch(
                    "lottoHolidays/deleteHoliday",
                    this.delete_id
                );
                if (data.success) {
                    this.$notify({
                        type: "success",
                        title: "สำเร็จ",
                        text: "ลบวันหยุดเรียบร้อย",
                    });
                    this.$emit("createSuccess", {
                        cate_id: this.category,
                    });
                } else if (!data.success && data.message) {
                    this.$notify({
                        type: "error",
                        title: "ล้มเหลว",
                        text: data.message,
                    });
                } else {
                    this.$notify({
                        type: "error",
                        title: "ล้มเหลว",
                        text: "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง",
                    });
                }
                this.$emit("deleteEvent", this.delete_id);
            } catch (err) {
                const errMsg =
                    (err &&
                        err.response &&
                        err.response.data &&
                        err.response.data.message) ||
                    err.message ||
                    "พบปัญหากับระบบกรุณาลองใหม่อีกครั้งภายหลัง";
                this.$notify({
                    type: "error",
                    title: "Error",
                    text: errMsg,
                });
            }
            this.on_delete = false;
        },
    },
};
</script>
